import { IoIosMore } from "react-icons/io";
import { useDispatch } from "react-redux";
import ResponsivePagination from 'react-responsive-pagination';
import { formatDateTime } from "../../utils/FormateDate";
import { CompliantStatusEnum, TransactionStatus } from "../../utils/Enums";
import { useEffect } from "react";
import { fetchComplaints } from "../../redux/slices/complaintSlice";
import Loader from "../Loader";

const ComplaintTable = ({ onRowClick, data, itemsPerPage, currentPage, setCurrentPage, isLoading, totalRecord }) => {
  
  const dispatch = useDispatch()

  const totalPages = Math.ceil(totalRecord / itemsPerPage);
  
  useEffect(() =>{
      dispatch(fetchComplaints())
  }, [dispatch]);

  return (
    <div>
      <div className="mt-6 overflow-x-auto sm:-px-6 lg:-px-8 rounded-lg border border-primaryGray border-t-0">
        <div className="inline-block min-w-full align-middle">
          <table className="min-w-full divide-y divide-gray-300 table-auto px-3">
            <thead className="bg-primaryGray">
              <tr>
                <th scope="col" className="whitespace-nowrap py-3.5 pl-3 text-left text-xs md:text-sm font-semibold text-gray-900">
                  S/N
                </th>
                <th scope="col" className="whitespace-nowrap py-3.5  pl-3 text-left text-xs md:text-sm font-semibold capitalize text-gray-900">
                  complaint I.D
                </th>
                <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-xs md:text-sm font-semibold capitalize text-gray-900">
                  issue
                </th>
                <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-xs md:text-sm text-left font-semibold capitalize text-gray-900">
                  Date and Time Received
                </th>
                <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-center lg:text-left text-xs md:text-sm font-semibold capitalize text-gray-900">
                  Status
                </th>
                <th scope="col" className="whitespace-nowrap px-3 py-3.5 text-left text-xs md:text-sm font-semibold capitalize text-gray-900">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                  <Loader />
                ): data && data.length > 0 ? (
              data && data?.map((items, index) => (
                <tr key={items.id}
                  onClick={() => onRowClick(items.id)}
                  className="border-b border-b-primaryGray cursor-pointer"
                >
                  <td className="whitespace-nowrap px-3 py-3 text-xs md:text-sm text-black capitalize">{index + 1}</td>
                  <td className="whitespace-nowrap px-3 text-xs md:text-sm text-black capitalize"> {items?.code}</td>
                  <td className="whitespace-nowrap px-3 text-xs md:text-sm text-black capitalize">{items?.issue}</td>
                  <td className="whitespace-nowrap px-3 text-xs md:text-sm text-black capitalize">
                  {formatDateTime(items.dateCreated)}
                  </td>
                  <td className={`text-xs md:text-sm text-black capitalize inline-block w-[120px] text-center whitespace-nowrap px-3 py-2 my-2 rounded-md
                    ${
                      CompliantStatusEnum[items?.status] === 'Resolved'
                      ? 'bg-[#008000] text-white'
                      : CompliantStatusEnum[items?.status] === 'Open'
                      ? 'bg-[#4A90E2] text-white'
                      : CompliantStatusEnum[items?.status] === 'In Progress'
                      ? 'bg-orange text-black'
                      : "bg-primaryGray text-black"
                      }
                    `}>
                    <span>
                      {CompliantStatusEnum[items?.status]}
                    </span>
                    </td>
                  <td className="whitespace-nowrap px-3 text-xs md:text-sm text-[#B3B3B3] text-center">{<IoIosMore />}</td>
                </tr>
               )))
               : <p className="text-sm text-primaryRed text-center py-4">No Available Custtomers</p>
             }
            </tbody>
          </table>
        </div>
      </div>
      <nav className="grid place-items-center mt-10">
        <ResponsivePagination
          current={currentPage}
          total={totalPages}
          onPageChange={setCurrentPage}
          extraClassName="custom-pagination"
          />
      </nav>
    </div>
  );
};

export default ComplaintTable;
